import { render, staticRenderFns } from "./MakeReport.vue?vue&type=template&id=be5b638e&scoped=true"
import script from "./MakeReport.vue?vue&type=script&lang=js"
export * from "./MakeReport.vue?vue&type=script&lang=js"
import style0 from "./MakeReport.vue?vue&type=style&index=0&id=be5b638e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5b638e",
  null
  
)

export default component.exports